import { render } from "./CGU.vue?vue&type=template&id=d44cd74a&scoped=true"
import script from "./CGU.vue?vue&type=script&lang=js"
export * from "./CGU.vue?vue&type=script&lang=js"

import "./CGU.vue?vue&type=style&index=0&id=d44cd74a&lang=scss&scoped=true"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d44cd74a"]])

export default __exports__